/**
 * Created by vblanco on 27/04/2017.
 */
(function () {
    'use strict';

    angular.module('app')
        .factory('Relacion', Relacion);

    /* @ngInject */
    function Relacion($resource) {
        return $resource('api/admin/relacion/:id', {}, {
            'query': {
                method: 'GET',
                isArray: true,
                url: 'api/public/relacion/query'
            },
            'get': {
                method: 'GET',
                url: 'api/public/relacion/:id'
            },
            'getNombreAndBdrs': {
                method: 'GET',
                url: 'api/public/relacion/getNombreAndBdrs'
            },
            'findAll': {
                method: 'GET',
                isArray: false,
                url: 'api/public/relacion/findAll'
            },
            'findUsedLetters': {
                method: 'GET',
                isArray: true,
                url: 'api/public/relacion/findUsedLetters'
            }
        });
    }
})();
